import React from 'react'

import TextEditor, { TEXT_EDITOR_MODES } from 'components/TextEditor/TextEditor'

/**
 * CTA button
 */
class Button extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            html: props.text,
            focused: false,
        }
    }

    render() {
        const {
            blockData: { t, text, id, brad, bc },
            onUpdate,
        } = this.props
        const st = {
            borderRadius: brad + 'px',
            backgroundColor: bc,
        }
        return (
            <div className={`block __${t}`}>
                <div className="rbtn" style={st}>
                    <TextEditor
                        id={id}
                        content={text}
                        propName={'text'}
                        mode={TEXT_EDITOR_MODES.BUTTON}
                        onChange={html => {
                            onUpdate({
                                [id]: {
                                    data: { text: html },
                                },
                            })
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default Button
